import { render, staticRenderFns } from "./ArtistDetails.vue?vue&type=template&id=39738c59&"
import script from "./ArtistDetails.vue?vue&type=script&lang=ts&"
export * from "./ArtistDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports